/**
 * Image loader - adds 'loaded' class to images when they finish loading
 * This enables skeleton loading states in CSS
 */
document.addEventListener('DOMContentLoaded', function() {
  const initImageLoaders = () => {
    const images = document.querySelectorAll('.thumbnails img:not(.loaded)');

    images.forEach(img => {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', function() {
          this.classList.add('loaded');
        });
        img.addEventListener('error', function() {
          this.classList.add('loaded');
        });
      }
    });
  };

  // Run on page load
  initImageLoaders();

  // Re-run when Sprig updates the DOM
  document.body.addEventListener('htmx:afterSwap', initImageLoaders);
});
